import { render, staticRenderFns } from "./waiting.vue?vue&type=template&id=250c9444&"
import script from "./waiting.vue?vue&type=script&lang=ts&"
export * from "./waiting.vue?vue&type=script&lang=ts&"
import style0 from "./waiting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports